import { useEffect, useState } from 'react';
import axios from 'axios';
import { TicketCategory } from 'src/components/Tickets/models/Tickets.interface';

export const useGetTicketCategories = () => {
  const [ticketCategories, setTicketCategories] = useState<TicketCategory[]>();
  const [isLoadingTicketCategories, setIsLoadingTicketCategories] =
    useState<boolean>();
  const [ticketCategoriesErrors, setTicketCategoriesErrors] =
    useState<unknown>();

  const getTicketCategories = async () => {
    setIsLoadingTicketCategories(true);
    try {
      const response = await axios.get('api/ticket-categories');

      setTicketCategories(response.data);
    } catch (error) {
      console.error(error);
      setTicketCategoriesErrors(error);
    } finally {
      setIsLoadingTicketCategories(false);
    }
  };

  useEffect(() => {
    getTicketCategories();
  }, []);

  return {
    ticketCategories,
    isLoadingTicketCategories,
    ticketCategoriesErrors,
  };
};
